import { takeEvery } from 'redux-saga'
import { put, select } from 'redux-saga/effects'
import { CANCEL_SCALE_FLOOR_PLAN } from 'actions/floorPlanActionTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import { updateFloorPlanAction } from 'actions/floorPlanActions'
import { updateUiAction } from 'actions/uiActions'
import { cancelScaleFloorPlanSelector } from 'selectors'
import FloorPlanScalerOverlay from 'components/FloorPlan/FloorPlanScalerOverlay'

export function * cancelScaleFloorPlan(action) {
  try {
    const { id, scaler } = yield select(cancelScaleFloorPlanSelector)

    scaler && scaler.setMap(null)
    yield put(updateUiAction({ scaling: false, floorPlanScaleID: null }))
    yield put(updateFloorPlanAction(id, { scaler: null }))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for cancel scale floor plan action, then call function */
export function * watchCancelScaleFloorPlan() {
  yield * takeEvery(CANCEL_SCALE_FLOOR_PLAN, cancelScaleFloorPlan)
}



// WEBPACK FOOTER //
// ./src/sagas/cancelScaleFloorPlanSaga.js